const waterPurifierDetailedRateCard = {
  key: "water-purifier",
  title: "Water Purifier Detailed Rate Card",
  note:
    "Indicative purifier pricing. RO membrane, PCB, motor, filter, and leakage complexity can change final pricing.",
  sections: [
    {
      title: "Inspection",
      items: [
        { name: "Purifier inspection", price: "₹249 visit" },
      ],
    },
    {
      title: "Service & Repair",
      items: [
        { name: "Basic purifier servicing", price: "₹499 onwards" },
        { name: "Leakage issue support", price: "₹399 onwards" },
        { name: "Flow / output issue support", price: "₹399 onwards" },
      ],
    },
    {
      title: "Installation",
      items: [
        { name: "Purifier installation", price: "₹599 onwards" },
      ],
    },
  ],
};

export default waterPurifierDetailedRateCard;